<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-3">
      <search-form :fields="search" />
      <el-button @click="jumpRegistered" v-if="hasPermUserCreate">代注册</el-button>
    </el-button-group>

    <el-row class="grid-content bg-el-row " v-for="item in users" :key="item.id" v-loading="loading">
      <el-col :xl="24" :xs="24" :sm="24" :md="24" :lg="24">
        <div class="grid-content-col-title">
          <el-col :xl="8" :xs="24" :md="24" :lg="8" :sm="24">
            <div>
              <i class="el-icon-guide" />
              <!-- {{ scope.row.auth_code }} -->
              {{ item.real_name }}<span v-if="item.level_name">({{ item.level_name }})</span>
              <el-tag v-if="item.status === 0" type="warning" disable-transitions>{{ item.status_text }}</el-tag>
              <el-tag v-if="item.status === 1" type="success" disable-transitions>{{ item.status_text }}</el-tag>
              <el-tag v-if="item.status === 2" type="danger" disable-transitions>{{ item.status_text }}</el-tag>
            </div>
          </el-col>
          <el-col :xl="6" :xs="6" :md="6" :lg="5" :sm="6">
            <div>
              报单状态：
              <el-tag v-if="item.debit_advice_status === 0" type="warning" disable-transitions>{{ item.debit_advice_status_text }}</el-tag>
              <el-tag v-if="item.debit_advice_status === 1" type="info" disable-transitions>{{ item.debit_advice_status_text }}</el-tag>
              <el-tag v-if="item.debit_advice_status === 2" type="success" disable-transitions>{{ item.debit_advice_status_text }}</el-tag>
              <el-tag v-if="item.debit_advice_status === 3" type="danger" disable-transitions>{{ item.debit_advice_status_text }}</el-tag>
            </div>
          </el-col>
          <el-col :xl="6" :xs="6" :md="6" :lg="4" :sm="6">
            <div>
              &nbsp;
            </div>
          </el-col>
          <el-col :xl="3" :xs="8" :md="8" :lg="5" :sm="8">
            <div>
              <span><i class="el-icon-pie-chart" />：</span>{{ item.created_at }}
            </div>
          </el-col>
          <el-col :xl="1" :xs="4" :md="4" :lg="2" :sm="4">
            <div class="action">
              <el-dropdown>
                <el-button size="small">操作</el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-finished" v-if="item.status === 0 && hasPermsAudit" divided>
                    <el-button @click="showAuditDialog(item)" type="text" size="small">会员审核</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="hasPermsEdit" icon="el-icon-view" divided>
                    <router-link :to="'/users/' + item.id + '/edit'"><el-button type="text" size="small">查看详情</el-button></router-link>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="hasPermsModifyWallet" icon="el-icon-edit" divided>
                    <el-button type="text" size="small" @click="showWalletModifyDialog(item, 1, '复销余额修改')">复销余额修改</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="hasPermsModifyWallet" icon="el-icon-edit">
                    <el-button type="text" size="small" @click="showWalletModifyDialog(item, 2, '奖金修改')">奖金修改</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="hasPermsModifyWallet" icon="el-icon-edit">
                    <el-button type="text" size="small" @click="showWalletModifyDialog(item, 3, '报单余额修改')">报单余额修改</el-button>
                  </el-dropdown-item>
                  <el-dropdown-item v-if="hasPermChangePassword" icon="el-icon-key" divided>
                    <el-button type="text" size="small" @click="showChangePasswordDialog(item)">设置密码</el-button></el-dropdown-item
                  >
                  <el-dropdown-item v-if="hasPermUnBindWechat" icon="el-icon-remove-outline">
                    <el-button type="text" size="small" @click="showUnBindWechatConfirm(item)">解绑微信</el-button></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </el-col>
        </div>
      </el-col>
      <el-col :xl="24" :xs="24" :md="24" :lg="24" :sm="24">
        <div class="grid-content-col-body">
          <el-col :xl="18" :xs="18" :md="18" :lg="17" :sm="24">
            <div class="grid-body-right">
              <el-col :xl="24" :xs="24" :md="24" :lg="24" :sm="24">
                <div class="grid-body-right-content grid-body-right-content-first">
                  <el-col :xl="8" :xs="24" :md="24" :lg="8" :sm="24">
                    <div class="grid-right-top">授权码：{{ item.auth_code }}</div>
                  </el-col>
                  <el-col :xl="8" :xs="24" :md="24" :lg="8" :sm="24">
                    <div class="grid-right-top">账户/手机：{{ item.username }}</div>
                  </el-col>
                  <el-col :xl="8" :xs="24" :md="24" :lg="8" :sm="24">
                    <div class="grid-right-top grid-right-top-last">注册类型：{{ item.register_type_text }}</div>
                  </el-col>
                </div>
              </el-col>

              <el-col :xl="24" :xs="24" :md="24" :lg="24" :sm="24">
                <div class="grid-body-right-content grid-body-right-content-first">
                  <el-col :xl="8" :xs="24" :md="24" :lg="8" :sm="24">
                    <div class="grid-right-top">区域：{{ item.area_text }}</div>
                  </el-col>
                  <el-col :xl="8" :xs="24" :md="24" :lg="8" :sm="24">
                    <div class="grid-right-top">&nbsp;</div>
                  </el-col>
                  <el-col :xl="8" :xs="24" :md="24" :lg="8" :sm="24">
                    <div class="grid-right-top grid-right-top-last">&nbsp;</div>
                  </el-col>
                </div>
              </el-col>
            </div>
          </el-col>
          <el-col :xl="6" :xs="24" :md="24" :lg="6" :sm="24">
            <div class="grid-body-left">
              <ul>
                <!-- <span>服务管理：</span> -->
                <li>
                  开通:
                  <el-switch
                    active-text="是"
                    inactive-text="否"
                    v-model="item.agent_disabled"
                    field="agent_disabled"
                    @change="onUpdateUserOtherStatus(item, 1)"
                  />
                </li>
                <li>
                  提现:
                  <el-switch
                    active-text="是"
                    inactive-text="否"
                    v-model="item.enable_withdrawal"
                    field="enable_withdrawal"
                    @change="onUpdateUserOtherStatus(item, 2)"
                  />
                </li>
                <li>
                  招募:
                  <el-switch
                    active-text="是"
                    inactive-text="否"
                    v-model="item.recruit_disabled"
                    field="recruit_disabled"
                    @change="onUpdateUserOtherStatus(item, 3)"
                  />
                </li>
              </ul>
            </div>
          </el-col>
        </div>
      </el-col>
    </el-row>

    <div class="card-footer"><pagination :page="page" /></div>

    <el-dialog title="设置密码" :visible.sync="changePasswordDialog" width="400px" append-to-body>
      <lz-form
        style="width: auto;"
        ref="passwordForm"
        :submit="onChangePassword"
        :errors.sync="errors"
        :model="passwordForm"
        label-position="top"
        in-dialog
        disable-redirect
        disable-stay
      >
        <el-form-item label="设置密码" required prop="password"><el-input v-model="passwordForm.password"/></el-form-item>
        <el-form-item label="确认密码" required prop="confirmPassword"><el-input v-model="passwordForm.confirmPassword"/></el-form-item>
      </lz-form>
    </el-dialog>

    <el-dialog :title="walletForm.title" :visible.sync="walletModifyDialog" width="400px" append-to-body>
      <lz-form
        style="width: auto;"
        ref="walletForm"
        :submit="onModifyWallet"
        :errors.sync="errors"
        :model="walletForm"
        label-position="left"
        in-dialog
        disable-redirect
        disable-stay
      >
        <el-form-item label="会员简要">
          <span>
            <i class="el-icon-user" />
            {{ user.real_name }}
          </span>
          <span v-if="user.level_info">({{ user.level_info.level_name }})</span>
        </el-form-item>
        <el-form-item label="修改金额" required prop="amount">
          <el-input v-model="walletForm.amount" />
          <el-alert title="减少请输入负数" type="warning" :closable="false" />
        </el-form-item>
        <el-form-item label="备注" required prop="remark"
          ><el-input type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" v-model="walletForm.remark"
        /></el-form-item>
      </lz-form>
    </el-dialog>

    <el-dialog title="会员审核" :visible.sync="auditModifyDialog" width="400px" append-to-body>
      <lz-form
        style="width: auto;"
        label-width="auto"
        ref="auditForm"
        :submit="onModifyAudit"
        :errors.sync="errors"
        :model="auditForm"
        label-position="left"
        in-dialog
        disable-redirect
        disable-stay
      >
        <el-form-item label="会员简要">
          <span>
            <i class="el-icon-user" />
            {{ user.real_name }}
          </span>
          <span v-if="user.level_info">({{ user.level_info.level_name }})</span>
        </el-form-item>
        <el-form-item label="充值金额">
          <el-input required v-model="auditForm.amount" disabled />
          <br />
          <span style="color: #c0c4cc;">报单金额: {{ auditForm.amount }}</span>
        </el-form-item>
        <el-form-item required prop="state" label="结果">
          <el-select v-model="auditForm.state" placeholder="请选择">
            <el-option v-for="item in auditOptions" :key="item.value" :label="item.label" :value="item.value"
          /></el-select>
        </el-form-item>
        <el-form-item label="备注" required prop="remark">
          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 3 }" v-model="auditForm.remark" />
        </el-form-item>
      </lz-form>
    </el-dialog>
  </el-card>
</template>

<script>
import LzForm from '@c/LzForm'
import SearchForm from '@c/SearchForm'
import Pagination from '@c/Pagination'
import { getUsers, changePassword, unbindWechat, modifyWallet, updateUserOtherStatus, audit } from '@/api/users'
import { can } from '@/libs/utils'

export default {
  name: 'Index',
  components: {
    LzForm,
    SearchForm,
    Pagination,
  },
  data() {
    return {
      search: [
        {
          field: 'keyword',
          label: '手机/姓名',
        },
        {
          field: 'auth_code',
          label: '授权码',
        },
        {
          field: 'idcard_no',
          label: '身份证',
        },
        {
          field: 'debit_advice_status',
          label: '报单状态',
          type: 'el-select',
          options: [
            {
              id: 0,
              name: '待申请',
            },
            {
              id: 1,
              name: '申请中',
            },
            {
              id: 2,
              name: '审核成功',
            },
            {
              id: 3,
              name: '审核失败',
            },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
        {
          field: 'status',
          label: '状态',
          type: 'el-select',
          options: [
            {
              id: 0,
              name: '待审核',
            },
            {
              id: 1,
              name: '已授权',
            },
            {
              id: 2,
              name: '审核失败',
            },
          ],
          labelField: 'name', // 默认为 name
          valueField: 'id', // 默认为 id
        },
        {
          field: 'created_at',
          label: '注册时间',
          type: 'el-date-picker',
        },
      ],
      users: [],
      user: {},
      page: null,

      changePasswordDialog: false,
      passwordForm: {
        password: '',
        confirmPassword: '',
      },
      walletModifyDialog: false,
      walletForm: {
        title: '',
        type: 1,
        amount: '',
        remark: '',
      },

      auditModifyDialog: false,
      auditForm: {
        id: 0,
        state: 1,
        amount: 0,
        remark: '',
      },
      auditOptions: [
        {
          value: 1,
          label: '审核通过',
        },
        {
          value: 2,
          label: '审核失败',
        },
      ],
      errors: {},
      query: {},
      userLevelList: [],
      firstLoad: true,
      loading: true,
      hasPermsEdit: false,
      hasPermsAudit: false,
      hasPermsModifyWallet: false,
      hasPermChangePassword: false,
      hasPermUnBindWechat: false,
      hasPermchangeOtherStatus: false,
      hasPermUserCreate: false,
    }
  },
  watch: {
    $route: {
      async handler(newVal) {
        this.query = newVal.query
        this.loadUsers()
      },
      immediate: true,
    },
  },
  created() {
    this.hasPermsEdit = can('users.edit')
    this.hasPermsAudit = can('users.audit')
    this.hasPermsModifyWallet = can('users.modify-wallet')
    this.hasPermChangePassword = can('users.change-password')
    this.hasPermUnBindWechat = can('users.unbind-wechat')
    this.hasPermchangeOtherStatus = can('users.change.other.status')
    this.hasPermUserCreate = can('users.create')
  },
  methods: {
    async loadUsers() {
      this.loading = true
      const {
        data: { data, meta, userLevelList },
      } = await getUsers(this.query)
      this.users = data
      this.page = meta
      this.loading = false
      if (this.firstLoad) {
        this.search.push({
          field: 'level_id',
          label: '等级',
          type: 'el-select',
          options: userLevelList,
          labelField: 'level_name', // 默认为 name
          valueField: 'id', // 默认为 id
        })
      }
      this.firstLoad = false
    },
    async goToDetail(index, row) {},
    async showChangePasswordDialog(item) {
      this.changePasswordDialog = true
      this.user = item
    },
    async showUnBindWechatConfirm(item) {
      this.$confirm('此操作将解除微信绑定, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const { data } = await unbindWechat(item.id)
          this.loadUsers()
          //
          this.$message({
            type: 'success',
            message: '解绑成功!',
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消解绑',
          })
        })
    },
    async showWalletModifyDialog(item, type, title) {
      this.walletModifyDialog = true
      this.user = item
      this.walletForm.type = type
      this.walletForm.title = title
    },
    async showAuditDialog(item) {
      this.user = item
      if (item.level_info) {
        this.auditForm.amount = item.level_info.bill_amount
      }

      this.auditForm.id = item.id
      this.auditModifyDialog = true
    },
    async onChangePassword() {
      const { data } = await changePassword(this.user.id, this.passwordForm)
      this.changePasswordDialog = false
      this.loadUsers()
    },
    async onModifyWallet() {
      const { data } = await modifyWallet(this.user.id, this.walletForm)
      this.walletModifyDialog = false
      this.loadUsers()
      this.walletForm.amount = ''
      this.walletForm.remark = ''
    },
    async onUpdateUserOtherStatus(row, type) {
      const { data } = await updateUserOtherStatus(row.id, { type: type })
      this.loadUsers()
    },
    async onModifyAudit() {
      const { data } = await audit(this.auditForm.id, this.auditForm)
      this.auditModifyDialog = false
      this.loadUsers()
      this.auditForm = {
        id: 0,
        state: 1,
        amount: 0,
        remark: '',
      }
    },
    async jumpRegistered() {
      this.$router.push('/users/create')
    },
  },
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 15px;
  font-size: 14px;
  &:last-child {
    margin-bottom: 0;
  }
}
.bg-el-row {
  border: 1px solid #d8d8d8;
}
.grid-content-col-title {
  min-height: 45px;
  line-height: 45px;
  padding: 0 10px;
  background-color: #f5f5f6;
  border-bottom: 1px solid #d8d8d8;
  color: #000;
  .action {
    text-align: right;
  }
}
.grid-content-col-body {
  min-height: 90px;
  color: #666;
  .grid-body-left {
    padding-bottom: 10px;
    ul {
      margin: 0;
      padding: 0;
      width: 100%;
      span {
        margin: 10px 0 0 10px;
        display: inline-block;
      }
      li {
        list-style: none;
        line-height: 26px;
        margin-left: 40px;
        span {
          margin-left: 10px;
        }
      }
    }
  }
  .grid-body-right {
    .grid-body-right-content {
      min-height: 45px;
      line-height: 45px;
      padding-left: 20px;
      .grid-right-top {
        padding-left: 20px;
      }
      .grid-right-top-fist {
        padding-left: 0;
      }
      .grid-right-top-last {
        border-right: 0;
      }
    }
    .grid-body-right-content-first {
      padding-left: 0;
    }
    .grid-body-right-content-last {
      border-bottom: 0;
    }
  }
}
</style>
